import apiPdca from '../../../../helpers/apiPdca'
import { loaded, loading } from '../../../../layout/redux/layoutActions'
import { AddAlert } from '../../../../components'

export const INTEGRATIONS_FETCH_REQUEST = 'INTEGRATIONS_FETCH_REQUEST'
export const INTEGRATIONS_FETCH_SUCCESS = 'INTEGRATIONS_FETCH_SUCCESS'
export const INTEGRATIONS_FETCH_FAILURE = 'INTEGRATIONS_FETCH_FAILURE'

export const INTEGRATIONS_OPEN_CONNECT_FORM = 'INTEGRATIONS_OPEN_CONNECT_FORM'
export const INTEGRATIONS_CLOSE_CONNECT_FORM = 'INTEGRATIONS_CLOSE_CONNECT_FORM'

export const INTEGRATIONS_OPEN_RECONFIGURE_FORM = 'INTEGRATIONS_OPEN_RECONFIGURE_FORM'
export const INTEGRATIONS_CLOSE_RECONFIGURE_FORM = 'INTEGRATIONS_CLOSE_RECONFIGURE_FORM'

export const INTEGRATIONS_OPEN_REPLACE_MODAL = 'INTEGRATIONS_OPEN_REPLACE_MODAL'
export const INTEGRATIONS_CLOSE_REPLACE_MODAL = 'INTEGRATIONS_CLOSE_REPLACE_MODAL'

export const INTEGRATIONS_OPEN_DISCONNECT_MODAL = 'INTEGRATIONS_OPEN_DISCONNECT_MODAL'
export const INTEGRATIONS_CLOSE_DISCONNECT_MODAL = 'INTEGRATIONS_CLOSE_DISCONNECT_MODAL'

export const INTEGRATIONS_SUBMIT_REQUEST = 'INTEGRATIONS_SUBMIT_REQUEST'
export const INTEGRATIONS_SUBMIT_SUCCESS = 'INTEGRATIONS_SUBMIT_SUCCESS'
export const INTEGRATIONS_SUBMIT_FAILURE = 'INTEGRATIONS_SUBMIT_FAILURE'

export const INTEGRATIONS_VALIDATION_MARK_INVALID = 'INTEGRATIONS_VALIDATION_MARK_INVALID'
export const INTEGRATIONS_CLEAR_STATE = 'INTEGRATIONS_CLEAR_STATE'

export const TOOL_CONFIG = {
  asana: {
    id: 1,
    code: 'asana',
    name: 'Asana',
    type: 'manual'
  },
  trello: {
    id: 2,
    code: 'trello',
    name: 'Trello',
    type: 'oauth'
  },
  clickup: {
    id: 3,
    code: 'clickup',
    name: 'ClickUp',
    type: 'oauth'
  },
  monday: {
    id: 4,
    code: 'monday',
    name: 'Monday.com',
    type: 'manual'
  },
  jira: {
    id: 5,
    code: 'jira',
    name: 'Jira Cloud',
    type: 'manual'
  }
}

export const TOOL_LIST = [
  TOOL_CONFIG.asana,
  TOOL_CONFIG.trello,
  TOOL_CONFIG.clickup,
  TOOL_CONFIG.monday,
  TOOL_CONFIG.jira
]

const normalizarTexto = valor => {
  if (valor === null || valor === undefined) return null
  const texto = String(valor).trim()
  return texto.length ? texto : null
}

const normalizarIntegration = data => {
  if (!data || data.existeIntegracao === false) {
    return null
  }

  return {
    existeIntegracao: true,
    ativo: !!data.ativo,
    ferramentaGestaoId: data.ferramentaGestaoId,
    ferramentaCodigo: normalizarTexto(data.ferramentaCodigo),
    ferramentaNomeExibicao: normalizarTexto(data.ferramentaNomeExibicao),
    tokenValidadoEm: normalizarTexto(data.tokenValidadoEm),
    tokenOwner: data.tokenOwner || null,
    createdAt: normalizarTexto(data.createdAt),
    updatedAt: normalizarTexto(data.updatedAt)
  }
}

const obterMensagemErro = (error, fallback) => {
  return (
    error?.response?.data?.complemento ||
    error?.response?.data?.message ||
    error?.message ||
    fallback
  )
}

const montarPayloadManual = ({ toolCode, tokenData }) => {
  const tool = TOOL_CONFIG[toolCode]

  if (!tool) {
    throw new Error(`Ferramenta manual não suportada: ${toolCode}`)
  }

  if (toolCode === 'jira') {
    return {
      ferramentaGestaoId: tool.id,
      tokenAcesso: JSON.stringify({
        baseUrl: tokenData?.baseUrl?.trim(),
        username: tokenData?.username?.trim(),
        apiToken: tokenData?.apiToken?.trim()
      })
    }
  }

  return {
    ferramentaGestaoId: tool.id,
    tokenAcesso: tokenData?.token?.trim()
  }
}

const obterMensagemSucessoConectar = (toolCode, nls) => {
  switch (toolCode) {
    case 'asana':
      return nls?.integrationConnectSuccessAsana || 'Integração Asana conectada com sucesso.'
    case 'monday':
      return nls?.integrationConnectSuccessMonday || 'Integração Monday.com conectada com sucesso.'
    case 'jira':
      return nls?.integrationConnectSuccessJira || 'Integração Jira Cloud conectada com sucesso.'
    default:
      return nls?.integrationConnectSuccess || 'Integração conectada com sucesso.'
  }
}

const obterMensagemErroConectar = (toolCode, nls) => {
  switch (toolCode) {
    case 'asana':
      return nls?.integrationConnectErrorAsana || 'Erro ao conectar integração Asana.'
    case 'monday':
      return nls?.integrationConnectErrorMonday || 'Erro ao conectar integração Monday.com.'
    case 'jira':
      return nls?.integrationConnectErrorJira || 'Erro ao conectar integração Jira Cloud.'
    default:
      return nls?.integrationConnectError || 'Erro ao conectar integração.'
  }
}

const obterMensagemSucessoReconfigurar = (toolCode, nls) => {
  switch (toolCode) {
    case 'asana':
      return nls?.integrationReconfigureSuccessAsana || 'Integração Asana atualizada com sucesso.'
    case 'monday':
      return nls?.integrationReconfigureSuccessMonday || 'Integração Monday.com atualizada com sucesso.'
    case 'jira':
      return nls?.integrationReconfigureSuccessJira || 'Integração Jira Cloud atualizada com sucesso.'
    default:
      return nls?.integrationReconfigureSuccess || 'Integração atualizada com sucesso.'
  }
}

const obterMensagemErroReconfigurar = (toolCode, nls) => {
  switch (toolCode) {
    case 'asana':
      return nls?.integrationReconfigureErrorAsana || 'Erro ao atualizar integração Asana.'
    case 'monday':
      return nls?.integrationReconfigureErrorMonday || 'Erro ao atualizar integração Monday.com.'
    case 'jira':
      return nls?.integrationReconfigureErrorJira || 'Erro ao atualizar integração Jira Cloud.'
    default:
      return nls?.integrationReconfigureError || 'Erro ao atualizar integração.'
  }
}

export const openConnectForm = toolCode => ({
  type: INTEGRATIONS_OPEN_CONNECT_FORM,
  payload: toolCode
})

export const closeConnectForm = () => ({
  type: INTEGRATIONS_CLOSE_CONNECT_FORM
})

export const openReconfigureForm = () => ({
  type: INTEGRATIONS_OPEN_RECONFIGURE_FORM
})

export const closeReconfigureForm = () => ({
  type: INTEGRATIONS_CLOSE_RECONFIGURE_FORM
})

export const openReplaceModal = toolCode => ({
  type: INTEGRATIONS_OPEN_REPLACE_MODAL,
  payload: toolCode
})

export const closeReplaceModal = () => ({
  type: INTEGRATIONS_CLOSE_REPLACE_MODAL
})

export const openDisconnectModal = () => ({
  type: INTEGRATIONS_OPEN_DISCONNECT_MODAL
})

export const closeDisconnectModal = () => ({
  type: INTEGRATIONS_CLOSE_DISCONNECT_MODAL
})

export const clearIntegrationsState = () => ({
  type: INTEGRATIONS_CLEAR_STATE
})

export const fetchIntegration = projetoId => {
  return async dispatch => {
    dispatch({ type: INTEGRATIONS_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.get(`/projetos/${projetoId}/integracao`)
      const integration = normalizarIntegration(response?.data)

      dispatch({
        type: INTEGRATIONS_FETCH_SUCCESS,
        payload: integration
      })
    } catch (error) {
      dispatch({
        type: INTEGRATIONS_FETCH_FAILURE,
        payload: obterMensagemErro(error, 'Erro ao carregar integração.')
      })
    } finally {
      dispatch(loaded())
    }
  }
}

export const connectManualIntegration = ({ projetoId, toolCode, tokenData, nls }) => {
  return async dispatch => {
    dispatch({
      type: INTEGRATIONS_SUBMIT_REQUEST,
      payload: 'connect'
    })
    dispatch(loading())

    try {
      const body = montarPayloadManual({ toolCode, tokenData })

      await apiPdca.put(`/projetos/${projetoId}/integracao`, body)

      dispatch({
        type: INTEGRATIONS_SUBMIT_SUCCESS,
        payload: {
          validationStatus: 'valid'
        }
      })

      dispatch(AddAlert('success', obterMensagemSucessoConectar(toolCode, nls)))
      dispatch(fetchIntegration(projetoId))
    } catch (error) {
      const mensagem = obterMensagemErro(
        error,
        obterMensagemErroConectar(toolCode, nls)
      )

      dispatch({
        type: INTEGRATIONS_SUBMIT_FAILURE,
        payload: {
          error: null
        }
      })

      dispatch(AddAlert('danger', mensagem))
    } finally {
      dispatch(loaded())
    }
  }
}

export const reconfigureManualIntegration = ({ projetoId, toolCode, tokenData, nls }) => {
  return async dispatch => {
    dispatch({
      type: INTEGRATIONS_SUBMIT_REQUEST,
      payload: 'reconfigure'
    })
    dispatch(loading())

    try {
      const body = montarPayloadManual({ toolCode, tokenData })

      await apiPdca.put(`/projetos/${projetoId}/integracao`, body)

      dispatch({
        type: INTEGRATIONS_SUBMIT_SUCCESS,
        payload: {
          validationStatus: 'valid'
        }
      })

      dispatch(AddAlert('success', obterMensagemSucessoReconfigurar(toolCode, nls)))
      dispatch(fetchIntegration(projetoId))
    } catch (error) {
      const mensagem = obterMensagemErro(
        error,
        obterMensagemErroReconfigurar(toolCode, nls)
      )

      dispatch({
        type: INTEGRATIONS_SUBMIT_FAILURE,
        payload: {
          error: null
        }
      })

      dispatch(AddAlert('danger', mensagem))
    } finally {
      dispatch(loaded())
    }
  }
}

export const validateIntegration = ({ projetoId, nls }) => {
  return async dispatch => {
    dispatch({
      type: INTEGRATIONS_SUBMIT_REQUEST,
      payload: 'validate'
    })
    dispatch(loading())

    try {
      await apiPdca.post(`/projetos/${projetoId}/integracao/validar`)

      dispatch({
        type: INTEGRATIONS_SUBMIT_SUCCESS,
        payload: {
          validationStatus: 'valid'
        }
      })

      dispatch(AddAlert('success', nls?.integrationValidateSuccess || 'Conexão validada com sucesso.'))
      dispatch(fetchIntegration(projetoId))
    } catch (error) {
      const mensagem = obterMensagemErro(
        error,
        nls?.integrationValidateError || 'Não foi possível validar a conexão.'
      )

      dispatch({
        type: INTEGRATIONS_VALIDATION_MARK_INVALID,
        payload: mensagem
      })

      dispatch({
        type: INTEGRATIONS_SUBMIT_FAILURE,
        payload: {
          error: null
        }
      })

      dispatch(AddAlert('danger', mensagem))
    } finally {
      dispatch(loaded())
    }
  }
}

export const disconnectIntegration = ({ projetoId, nls }) => {
  return async dispatch => {
    dispatch({
      type: INTEGRATIONS_SUBMIT_REQUEST,
      payload: 'disconnect'
    })
    dispatch(loading())

    try {
      await apiPdca.delete(`/projetos/${projetoId}/integracao`)

      dispatch({
        type: INTEGRATIONS_SUBMIT_SUCCESS,
        payload: {
          integration: null,
          validationStatus: null
        }
      })

      dispatch(AddAlert('success', nls?.integrationDisconnectSuccess || 'Integração desconectada com sucesso.'))
      dispatch(fetchIntegration(projetoId))
    } catch (error) {
      const mensagem = obterMensagemErro(
        error,
        nls?.integrationDisconnectError || 'Erro ao desconectar integração.'
      )

      dispatch({
        type: INTEGRATIONS_SUBMIT_FAILURE,
        payload: {
          error: null
        }
      })

      dispatch(AddAlert('danger', mensagem))
    } finally {
      dispatch(loaded())
    }
  }
}

// ============================
// TRELLO OAUTH
// ============================

export const iniciarOAuthTrello = ({ projetoId, nls }) => {
  return async dispatch => {
    dispatch(loading())

    try {
      const response = await apiPdca.get(`/projetos/${projetoId}/integracao/trello/authorize-url`)

      const authorizeUrl = response?.data?.authorizeUrl

      if (!authorizeUrl) {
        throw new Error('AuthorizeUrl não retornada')
      }

      // redireciona na mesma aba
      window.location.href = authorizeUrl

    } catch (error) {
      dispatch(AddAlert('danger', nls.trelloAuthorizeError || 'Erro ao iniciar integração com Trello'))
      dispatch(loaded())
    }
  }
}

export const iniciarOAuthClickupOLD = ({ projetoId, nls }) => {
  return async dispatch => {
    dispatch(loading())

    try {
      const response = await apiPdca.get(`/projetos/${projetoId}/integracao/clickup/authorize-url`)

      const authorizeUrl = response?.data?.authorizeUrl

      if (!authorizeUrl) {
        throw new Error('AuthorizeUrl não retornada')
      }

      window.location.href = authorizeUrl
    } catch (error) {
      dispatch(AddAlert('danger', nls.clickupAuthorizeError || 'Erro ao iniciar integração com ClickUp'))
      dispatch(loaded())
    }
  }
}


export const iniciarOAuthClickup = ({ projetoId, nls }) => {
  return async dispatch => {
    dispatch(loading())

    try {
      const response = await apiPdca.get(`/projetos/${projetoId}/integracao/clickup/authorize-url`)

      const authorizeUrl = response?.data?.authorizeUrl

      if (!authorizeUrl) {
        throw new Error('AuthorizeUrl não retornada')
      }

      window.open(authorizeUrl, '_blank', 'noopener=no,noreferrer=no')
      dispatch(loaded())
    } catch (error) {
      dispatch(AddAlert('danger', nls.clickupAuthorizeError || 'Erro ao iniciar integração com ClickUp'))
      dispatch(loaded())
    }
  }
}